import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledLessonWrapper = styled.div`
  padding: 10px 0;
`;

export const StyledLessonWrapperContent = styled.div<{
  isLearningIntentionSuccessCriteria?: boolean;
  isImportantTeachingPoint?: boolean;
}>`
  border: solid 1px ${COLORS.veryLightPink};
  padding: 20px;

  ${({ isLearningIntentionSuccessCriteria }) =>
    isLearningIntentionSuccessCriteria &&
    `
      background-color: ${COLORS.gray95};
    `}

  ${({ isImportantTeachingPoint }) =>
    isImportantTeachingPoint &&
    `
      border: dashed 1.5px ${COLORS.deepCarminePink};
    `}
`;
